import { Link } from 'react-router-dom'
import { Users, Image, BookOpen, Heart } from 'lucide-react'

export default function Home() {
  const features = [
    {
      icon: Users,
      title: 'Community Connection',
      description: 'Connect with fellow Kapcheboin clan members worldwide and strengthen our bonds.',
    },
    {
      icon: Image,
      title: 'Cultural Artifacts',
      description: 'Preserve and share our precious cultural artifacts for future generations.',
    },
    {
      icon: BookOpen,
      title: 'Stories & Traditions',
      description: 'Share stories, traditions, and knowledge through our community blog.',
    },
    {
      icon: Heart,
      title: 'Heritage Preservation',
      description: 'Safeguard our rich cultural heritage through digital preservation.',
    },
  ]

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center bg-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 text-shadow">
              Welcome to the
              <br />
              <span className="text-primary-400">Kapcheboin Clan</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-4xl mx-auto text-shadow-light">
              Preserving our rich cultural heritage and connecting our community 
              across generations through digital storytelling and artifact preservation.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link to="/register" className="btn-primary text-lg px-8 py-4 text-center">
                Join Our Community
              </Link>
              <Link to="/artifacts" className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border-2 border-white/50 font-medium py-4 px-8 rounded-lg transition-all duration-200 text-lg text-center">
                Explore Heritage
              </Link>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="content-container p-12 mb-16">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Connecting Our Heritage
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto">
                Our platform brings together the past, present, and future of the Kapcheboin clan
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature, index) => {
                const Icon = feature.icon
                return (
                  <div key={index} className="card-glass text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <div className="w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                      <Icon className="w-10 h-10 text-white" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">
                      {feature.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card-glass text-center p-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              Be Part of Our Story
            </h2>
            <p className="text-xl mb-8 text-gray-700 max-w-3xl mx-auto leading-relaxed">
              Every artifact, every story, every connection strengthens our community. 
              Join us in preserving the Kapcheboin legacy for future generations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/register" className="btn-primary text-lg px-8 py-4">
                Get Started Today
              </Link>
              <Link to="/blog" className="btn-secondary text-lg px-8 py-4">
                Read Our Stories
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}